import { Tabs } from "@shared/ui/tabs";
import ReadCycleList from "../readCycleList/readCycleList";
import ScheduleLanding from "../schedule/landing/landing";

const ReadCycleLanding = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col space-y-4">
        <div className="w-full overflow-hidden">
          <Tabs
            defaultValue="readCycles"
            className="w-full"
            tabsListClassName="grid w-full grid-cols-2 mb-6 p-1"
            urlMapping={{
              readCycles: "readCycles",
              schedules: "schedules",
            }}
            tabComponents={{
              readCycles: {
                label: "Read Cycles",
                component: <ReadCycleList />,
              },
              schedules: {
                label: "Schedules",
                component: <ScheduleLanding />,
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ReadCycleLanding;
